import { axiosBasic } from "../api/axios";
import { config } from "../api/endPoints";
import { getSelectedCompany } from "../components/Global/CustomFunctions";

/** @param {Record<string, unknown> | null | undefined} office */
export const isActiveOffice = (office) => {
  if (!office || typeof office !== "object") return false;
  const isInactive =
    office.isActive === false ||
    office.isDeleted === true ||
    office.isDeactivated === true ||
    office.status === "Inactive" ||
    office.status === "Deleted";
  return !isInactive;
};

/** @param {unknown} offices */
export const filterActiveOffices = (offices) => {
  if (!Array.isArray(offices)) return [];
  return offices.filter(isActiveOffice);
};

/** Active company workplaces from `Office/GetCompanyOffices`. */
export const fetchActiveCompanyOffices = async () => {
  const { Office } = config.REST_API;
  const selectedCompany = getSelectedCompany();
  const url = selectedCompany?.id
    ? `${Office.GetCompanyOffices}?companyId=${selectedCompany.id}`
    : Office.GetCompanyOffices;
  const response = await axiosBasic.get(url);
  const { success, data } = response.data || {};
  if (!success || !Array.isArray(data)) return [];
  return filterActiveOffices(data);
};
